module.exports = __webpack_public_path__ + "img/bg_pic.cefc56c3.png";